import { useActivePaperTabletsSuspense } from 'src/api/queries';

import { SetupComplete } from '../components/SetupComplete';

export const ConnectOfferSetupComplete = () => {
  const activePaperTablets = useActivePaperTabletsSuspense();

  return (
    <SetupComplete
      secondDevice={
        !!(activePaperTablets.data && activePaperTablets.data.length > 1)
      }
    />
  );
};
